import { reportStatusEnum } from "../enums/reportStatusEnum";
import api from "./BaseServices";
import { boosterData } from "./BoosterServices";
import { ShowCardsType } from "./CardServices";
import { ReportSchema } from "./ReportServices";
import {
  printTransactionData,
  StoreTransactionsData,
} from "./TransactionServices";

export const getReports = async (): Promise<ReportSchema[]> => {
  const response = await api.get("/admin/reports/news");
  return response.data;
};

export const updateReport = async (
  id: number,
  status: reportStatusEnum,
  comment?: string
): Promise<ReportSchema> => {
  const response = await api.put(`/admin/reports/${id}`, { status, comment });
  return response.data;
};

export const getBoosters = async (): Promise<ShowCardsType[]> => {
  const response = await api.get("/admin/boosters/news");
  return response.data;
};

export const updateBooster = async (
  id: string,
  status: reportStatusEnum,
  comment?: string
): Promise<boosterData> => {
  const response = await api.put(`/admin/boosters/${id}`, {
    status,
    comment,
  });
  return response.data;
};

export const warnUser = async (
  username: string,
  reason: string,
  comment?: string
): Promise<void> => {
  await api.put(`/admin/users/${username}/warn`, { reason, comment });
};

export const banUser = async (
  username: string,
  reason: string,
  comment?: string
): Promise<void> => {
  await api.put(`/admin/users/${username}/ban`, { reason, comment });
};

export const getTransactionsPrints = async (): Promise<
  printTransactionData[]
> => {
  const response = await api.get("/admin/transactions/news");
  return response.data;
};

export const getPrintSheet = async (
  transactionId: number,
  boosterId: string
): Promise<string> => {
  return (
    process.env.REACT_APP_API_URL +
    "/admin/transactions/" +
    transactionId +
    "/sheet?boosterId=" +
    boosterId
  );
};

export const updateTransactionShippingStatus = async (
  transactionId: number,
  shippingStatus: string
): Promise<void> => {
  await api.put(`/admin/transactions/${transactionId}/status`, {
    shipping_status: shippingStatus,
  });
};

export const getShippingSlip = async (
  transactionId: number
): Promise<string> => {
  const slip = await api.put(
    `/admin/transactions/${transactionId}/shipping-slip`
  );

  return slip.data;
};

export const getBoosterPrintSheet = async (
  transactionId: number,
  boosterId: string
): Promise<string> => {
  return (
    process.env.REACT_APP_API_URL +
    `/admin/transactions/${transactionId}/boosterSheet?boosterId=${boosterId}`
  );
  // return response.data;
};

export const getRefundRequested = async (): Promise<
  (StoreTransactionsData & { type: string })[]
> => {
  const response = await api.get("/admin/transactions/refundRequested");
  return response.data;
};

export const refundBooster = async (
  transactionId: number,
  boosterId: string,
  comment?: string
): Promise<void> => {
  await api.put(
    `/admin/transactions/${transactionId}/boosters/${boosterId}/refund`,
    {
      comment,
    }
  );
};

export const refundPrint = async (
  transactionId: number,
  boosterId: string,
  comment?: string
): Promise<void> => {
  await api.put(
    `/admin/transactions/${transactionId}/prints/${boosterId}/refund`,
    {
      comment,
    }
  );
};

export const refusePrintRefund = async (
  transactionId: number,
  boosterId: string,
  status: string,
  comment?: string
): Promise<void> => {
  await api.put(
    `/admin/transactions/${transactionId}/prints/${boosterId}/status`,
    {
      comment,
      status,
    }
  );
};

export const refuseBoosterRefund = async (
  transactionId: number,
  boosterId: string,
  status: string,
  comment?: string
): Promise<void> => {
  await api.put(
    `/admin/transactions/${transactionId}/boosters/${boosterId}/status`,
    {
      comment,
      status,
    }
  );
};
